import { useEffect, useMemo, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router";
import {
  X,
  Mail,
  Phone,
  Building2,
  UserCircle2,
  IdCard,
  Clock,
  Copy,
  ExternalLink,
  ChevronRight,
  Briefcase,
  Monitor,
  FileText,
  User,
  Globe,
  Quote,
  Building,
  Calendar,
  Award,
  Map,
  Globe2,
  MailCheck,
  PhoneCall,
  Check,
  ThumbsDown,
  ThumbsUp,
  Trophy,
  XCircle,
  Pencil,
  Plus,
  PhoneCallIcon,
  FileTextIcon,
  TimerIcon,
  MessageCircle,
  MessageCircleCodeIcon,
  BadgeAlert,
  MapMinus,
  MapPinHouse,
  Warehouse,
  PhoneIcon,
  MailCheckIcon,
  CalendarSync,
  Slack,
  PackageSearch,
  Send,
  ALargeSmall,
} from "lucide-react";
import InnerLoader from "../../../../../component/ui/loader/inner-loader";
import Tooltip from "../../../../../component/ui/tooltip";
import Swal from "sweetalert2";
import { Alert, Snackbar } from "@mui/material";
import CommentsSection from "../../../../../component/comment";
import EmployeeDirectoryAddUpdate from "../../../../organization/emplyee-directory/add-update";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
import LostDeal from "../../../../mainDeals/deals/deal/lost-deal/lost-form-deal";
import WonDeal from "../../../../mainDeals/deals/deal/won-deal/won-form-deal";
import DealQuickView from "../../../../mainDeals/deals/deal/popup";
import Avatar from "../../../../../component/ui/avatar";
import AddActivity from "../../../../../component/modals/add-activity";
import { PopupTimeline } from "../../../../../component/ui/timeline";
import NewCardIcon from "../../../../../component/icons/action-card-icon";
import { FieldRow } from "../../../../../component/Popup-comp";
import Icon from "../../../../../component/icons/inner-pages-icons";

const tabs = [
  { key: "timeline", label: "Timeline", icon: <TimerIcon size={16} /> },
  { key: "summary", label: "Summary", icon: <User size={16} /> },
  { key: "deals", label: "Deals", icon: <FileTextIcon size={16} /> },
  {
    key: "comments",
    label: "Comments",
    icon: <MessageCircleCodeIcon size={16} />,
  },
  { key: "call", label: "Calls", icon: <PhoneCallIcon size={16} /> },
  { key: "emails", label: "Emails", icon: <Mail size={16} /> },
  { key: "sms", label: "Sms", icon: <MessageCircle size={16} /> },
];

function classNames(...xs) {
  return xs.filter(Boolean).join(" ");
}



function Field({ label, value, icon: Icon, copyable, link }) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="grid grid-cols-12 items-center gap-2 rounded-xl border border-solid border-slate-200 bg-white p-3 transition hover:bg-slate-50 shadow-card">
      <div className="col-span-4 flex items-center gap-2 text-[13px] font-medium text-slate-500">
        {Icon ? <Icon className="size-4" /> : null}
        {label}
      </div>
      <div className="col-span-8 flex items-center justify-between gap-2 text-[13px] text-slate-800">
        {link ? (
          <a
            href={link}
            className="truncate underline decoration-slate-300 underline-offset-2 hover:text-blue-600 hover:decoration-blue-400"
          >
            {value}
          </a>
        ) : (
          <span className="truncate">{value}</span>
        )}
        {copyable && (
          <button
            onClick={async () => {
              try {
                await navigator.clipboard.writeText(String(value ?? ""));
                setCopied(true);
                setTimeout(() => setCopied(false), 1500);
              } catch { }
            }}
            className="inline-flex items-center gap-1 rounded-md border border-solid border-slate-200 bg-white px-2 py-1 text-[11px] text-slate-600 hover:bg-slate-100"
          >
            <Copy className="size-3.5" /> {copied ? "Copied" : "Copy"}
          </button>
        )}
      </div>
    </div>
  );
}
const Chip2 = ({ label, tone = "info" }) => {
  const toneMap = {
    success: "bg-emerald-50 text-emerald-700 ring-emerald-200",
    danger: "bg-rose-50 text-rose-700 ring-rose-200",
    warning: "bg-amber-50 text-amber-700 ring-amber-200",
    info: "bg-sky-50 text-sky-700 ring-sky-200",
  };
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-[6px]  px-[9px] text-[11px] py-[3px] text-xs font-medium ring-1 ${toneMap[tone]}`}
    >
      <span
        className={`h-1.5 w-1.5 rounded-full ${tone === "success"
          ? "bg-emerald-500"
          : tone === "danger"
            ? "bg-rose-500"
            : tone === "warning"
              ? "bg-amber-500"
              : "bg-sky-500"
          }`}
      />
      {label}
    </span>
  );
};

export default function ContactQuickView({
  open = true,
  onClose = () => { },
  data,
  onAlert,
  ProductList = [],
  PackageList = [],
  DealStages = [],
  ClientList = [],
  UserList = [],
  onError = () => { },
  onSuccess = () => { },
  onDealUpdated,
}) {
  const [contact, setcontact] = useState({});
  const [activeTab, setActiveTab] = useState("timeline");
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState(contact?.contactstatus);
  const containerRef = useRef(null);
  const apiCall = useApiCall();
  const [isLoading, setIsLoading] = useState(false);
  const [showAddDealModal, setShowAddDealModal] = useState(false);
  const [clientDeals, setClientDeals] = useState([]);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [changeModal, setChangeModal] = useState(false);
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [usersList, setUsers] = useState([]);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const GetData = async (id) => {
    // setIsLoading(true);
    let apiData = JSON.stringify({
      userid: id,
    });

    try {
      let call = await apiCall({
        method: "get",
        url: `contacts/get-contact/${id}`,
        data: apiData,
      });
      let ContactData = call?.data;

      // console.log("ContactData", ContactData)

      let activity = ContactData?.recent_activity?.map((item) => {
        const dateObj = new Date(item.time);
        const formattedDate = dateObj
          .toISOString()
          .slice(0, 16)
          .replace("T", " ");
        // This gives "YYYY-MM-DD HH:MM"

        return {
          ts: formattedDate,
          text: item.data,
        };
      });

      const sdata = {
        // ---------- SUMMARY TAB ----------
        id: ContactData?.userid,
        name: ContactData?.name,
        email: ContactData?.email,
        phone: ContactData?.phone,
        source: ContactData?.product_name,
        page_source: ContactData?.page_source,
        created_at: ContactData?.created_at,
        stats: ContactData?.stats,
        brandurl: ContactData?.brand?.brandurl,

        // ---------- CUSTOMER INFORMATION TAB ----------
        altemail: ContactData?.altemail,
        alternatephone: ContactData?.alternatephone,
        usertype: ContactData?.usertype,
        country: ContactData?.country,
        tagline: ContactData?.tagline,
        userimg: ContactData?.userimg,
        companyname: ContactData?.companyname,
        address: ContactData?.address,
        city: ContactData?.city,
        state: ContactData?.state,
        zipcode: ContactData?.zipcode,
        verified: ContactData?.verified,
        verifykey: ContactData?.verifykey,
        badge: ContactData?.badge,
        view_tutorial: ContactData?.view_tutorial,
        active: ContactData?.active,
        theme: ContactData?.theme,
        AssignedTo: ContactData?.assigned_users,
        notify: ContactData?.notify,
        teamleadid: ContactData?.teamleadid,
        revoke_user: ContactData?.revoke_user,
        is_private: ContactData?.is_private,
        is_private_assignee: ContactData?.is_private_assignee,
        // signupdate: formatDate(ContactData?.signupdate),
        signupdate: ContactData?.signupdate_formated,
        // signuptime: formatTs(ContactData?.signuptime * 1000),
        signuptime: ContactData?.signuptime,
        client_deals: ContactData?.client_deals ?? [],

        brand: ContactData?.lead_brand?.brandname,
        agent: ContactData?.assigned_user_details,
        activities: ContactData?.activities,
      };

      setStatus(ContactData?.contactstatus);
      setcontact(sdata);
      setClientDeals(sdata.client_deals || []);
      setIsLoading(true);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const fetchUsers = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });

      console.log("Users API Response ===>", res);
      const newUsers = res?.agents || res?.customers || res?.data || [];
      setUsers(newUsers);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  
  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
      if (e.key.toLowerCase() === "f" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        const el = document.getElementById("quickview-search");
        el?.focus();
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  

  const handleSuccess = (message, type) => {
    // if (onSuccess) onSuccess(message);
    if (type == "won") {
      onClose();
      if (onAlert) {
        onAlert("success", message);
      }
    } else {
      setAlertData({ isShow: true, type: "success", message: message });
      GetData(contact?.id);
      setChangeModal(false);
      setShowAddDealModal(false);
    }
  };

  const onActivitySuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    GetData(contact?.id);
    setShowActivityModal(false);
  };

  useEffect(() => {
    if (activeTab === "timeline") {
      GetData(data?.userid || contact?.id);
    }
  }, [activeTab, data]);

  const fields = useMemo(
    () => [
      // ---------- SUMMARY TAB ----------
      { tab: "summary", label: "ID", value: contact?.id ?? "-", icon: IdCard },
      {
        tab: "summary",
        label: "Name",
        value: contact?.name ?? "-",
        icon: User,
      },
      {
        tab: "summary",
        label: "Email",
        value: contact?.email ?? "-",
        icon: Mail,
        copyable: true,
        link: `mailto:${contact?.email}`,
      },
      {
        tab: "summary",
        label: "Phone",
        value: contact?.phone ?? "-",
        icon: Phone,
        copyable: true,
        link: `tel:${contact?.phone}`,
      },
      {
        tab: "summary",
        label: "Product",
        value: contact?.source ?? "-",
        icon: ExternalLink,
      },
      {
        tab: "summary",
        label: "Brand",
        value: contact?.page_source ?? "-",
        icon: Globe,
      },
      {
        tab: "summary",
        label: "Date",
        value: contact?.signupdate ?? "-",
        icon: Calendar,
      },
      {
        tab: "summary",
        label: "Status",
        value:
          contact?.active == 1
            ? "Active"
            : contact?.active == 0
              ? "In Active"
              : "-",
        icon: Globe2,
      },
      // { tab: "summary", label: "Notify", value: contact?.notify, icon: Bell },
      // { tab: "summary", label: "Team Lead ID", value: contact?.teamleadid, icon: Users },
      {
        tab: "summary",
        label: "Assigned",
        value: (
          <div className="flex -space-x-2">
            {Array.isArray(contact?.AssignedTo) &&
              contact.AssignedTo.length > 0 ? (
              contact.AssignedTo.map((user, idx) => (
                <Tooltip key={idx} content={user.name} position="top center">
                  <div className={`relative ${idx !== 0 ? "-ml-0" : ""}`}>
                    {/* {user?.userimg ? (
                      <img
                        src={user.userimg}
                        alt={user.name}
                        className="h-8 w-8 rounded-full border-2 border-white object-cover object-center shadow-sm bg-white"
                        onError={(e) => {
                          e.target.onerror = null; // prevent infinite loop
                          e.target.style.display = "none";
                          const fallback = document.createElement("div");
                          fallback.className =
                            "h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 text-black text-xs font-medium border-2 border-white shadow-sm";
                          fallback.innerText = (
                            (user?.name?.split(" ")[0]?.[0] || "") +
                            (user?.name?.split(" ")[1]?.[0] || "")
                          ).toUpperCase();
                          e.target.parentElement.appendChild(fallback);
                        }}
                      />
                    ) : (
                      <div className="h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 text-black text-xs font-medium border-2 border-white shadow-sm">
                        {(user?.name?.split(" ")[0]?.[0] || "") +
                          (user?.name?.split(" ")[1]?.[0] || "")}
                      </div>
                    )} */}
                    <Avatar src={user?.userimg} title={user?.name} />
                  </div>
                </Tooltip>
              ))
            ) : (
              <span className="text-gray-400 text-sm">-</span>
            )}
          </div>
        ),
        icon: UserCircle2,
      },

      // ---------- CUSTOMER INFORMATION TAB ----------
      {
        tab: "customer_information",
        label: "Alternate Email",
        value: contact?.altemail ?? "-",
        icon: Mail,
        copyable: true,
        link: contact?.altemail ? `mailto:${contact?.altemail}` : null,
      },
      {
        tab: "customer_information",
        label: "Alternate Phone",
        value: contact?.alternatephone ?? "-",
        icon: Phone,
        copyable: true,
        link: contact?.alternatephone ? `tel:${contact?.alternatephone}` : null,
      },
      // { tab: "customer_information", label: "User Type", value: contact?.usertype, icon: FileText },
      {
        tab: "customer_information",
        label: "Country",
        value: contact?.country ?? "-",
        icon: Globe2,
      },
      {
        tab: "customer_information",
        label: "City",
        value: contact?.city ?? "-",
        icon: Building,
      },
      {
        tab: "customer_information",
        label: "State",
        value: contact?.state ?? "-",
        icon: Building2,
      },
      {
        tab: "customer_information",
        label: "Tagline",
        value: contact?.tagline ?? "-",
        icon: Quote,
      },
      {
        tab: "customer_information",
        label: "Company",
        value: contact?.companyname ?? "-",
        icon: Briefcase,
      },
      // { tab: "customer_information", label: "Address", value: contact?.address, icon: MapPin },
      {
        tab: "customer_information",
        label: "Zip Code",
        value: contact?.zipcode ?? "-",
        icon: Map,
      },
      // { tab: "customer_information", label: "Signup Time", value: contact?.signuptime, icon: Clock },
      {
        tab: "customer_information",
        label: "Badge",
        value: contact?.badge ?? "-",
        icon: Award,
      },
    ],
    [contact, status],
  );

 


  const [commentTypes, setCommentTypes] = useState([]);

  const getCommentTypes = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "get-dropdown-list",
      });
      console.log("res?.data", res?.data);
      setCommentTypes(res?.data?.comment_types || []);
    } catch (error) {
      console.warn("Error fetching Package:", error);
    }
  };
 

  const handleVerificationChange = (status) => {
    setcontact((prev) => ({
      ...prev,
      verified: status,
    }));
  };

  

  const T = {
    bg: "#EDE8E1",
    sidebar: "#1a1726",
    sidebarText: "rgba(255,255,255,0.45)",
    sidebarActive: "#FFFFFF",
    sidebarActiveBg: "rgba(99,102,241,0.15)",
    sidebarHover: "rgba(255,255,255,0.05)",
    sidebarAccent: "#818cf8",
    card: "#FFFFFF",
    cardBorder: "rgba(0,0,0,0.10)",
    cardHover: "#FAF8F6",
    text: "#1a1520",
    textSecondary: "#5c5466",
    textMuted: "#908892",
    border: "rgba(0,0,0,0.08)",
    accent: "#6366f1",
    accentLight: "#EEF0FF",
    accentText: "#4F46E5",
    inputBg: "#F3EFE9",
    inputBorder: "rgba(0,0,0,0.1)",
    modalBg: "#FFFFFF",
    rowHover: "#F5F1EC",
    selectedRow: "#EEEAFF",
    selectedBorder: "#6366f1",
    shadow: "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
    shadowLg: "0 8px 30px rgba(0,0,0,0.08)",
  };

  const css = {
    app: {
      display: "flex",
      height: "100vh",
      fontFamily: "'DM Sans', -apple-system, sans-serif",
      background: T.bg,
      color: T.text,
      overflow: "hidden",
    },
    sidebar: {
      width: 250,
      background: T.sidebar,
      display: "flex",
      flexDirection: "column",
      flexShrink: 0,
      overflow: "hidden",
    },
    main: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    card: {
      background: T.card,
      border: `1px solid ${T.cardBorder}`,
      borderRadius: 12,
      padding: 16,
      boxShadow: T.shadow,
    },
    btn: {
      padding: "7px 14px",
      borderRadius: 8,
      border: `1px solid ${T.border}`,
      background: T.card,
      color: T.textSecondary,
      cursor: "pointer",
      fontSize: 13,
      display: "flex",
      alignItems: "center",
      gap: 6,
      fontFamily: "inherit",
      transition: "all 0.15s",
      boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
    },
    btnPrimary: {
      padding: "8px 18px",
      borderRadius: 8,
      border: "none",
      background: "linear-gradient(92deg,#0057FB 1.54%,#003495 114.12%)",
      color: "#fff",
      cursor: "pointer",
      fontSize: 13,
      fontWeight: 600,
      display: "flex",
      alignItems: "center",
      gap: 6,
      fontFamily: "inherit",
      boxShadow: "0 2px 10px rgba(99,102,241,0.3)",
    },
    input: {
      background: T.inputBg,
      border: `1px solid ${T.inputBorder}`,
      borderRadius: 8,
      padding: "9px 12px",
      color: T.text,
      fontSize: 13,
      outline: "none",
      fontFamily: "inherit",
      width: "100%",
    },
    select: {
      background: T.inputBg,
      border: `1px solid ${T.inputBorder}`,
      borderRadius: 8,
      padding: "9px 12px",
      color: T.text,
      fontSize: 13,
      outline: "none",
      fontFamily: "inherit",
      cursor: "pointer",
    },
    badge: (color) => ({
      display: "inline-flex",
      alignItems: "center",
      padding: "3px 9px",
      borderRadius: 6,
      fontSize: 11,
      fontWeight: 600,
      background: color + "14",
      color: color,
      letterSpacing: "0.3px",
    }),
    pill: (active) => ({
      padding: "5px 12px",
      borderRadius: 20,
      fontSize: 12,
      fontWeight: active ? 600 : 400,
      border: active
        ? "1px solid rgba(99,102,241,0.35)"
        : `1px solid ${T.border}`,
      background: active ? T.accentLight : T.card,
      color: active ? T.accentText : T.textMuted,
      cursor: "pointer",
      fontFamily: "inherit",
      boxShadow: active ? "none" : "0 1px 2px rgba(0,0,0,0.03)",
    }),
  };

  const activityIcon = (type) =>
    ({
      call: "phone",
      email: "mail",
      sms: "msg",
      meeting: "users",
      note: "edit",
      voicemail: "mic",
    })[type] || "check";
  const activityColor = (type) =>
    ({
      call: "#6366f1",
      email: "#3b82f6",
      sms: "#059669",
      message: "#059669",
      chat: "#059669",
      meeting: "#d97706",
      note: "#8b5cf6",
      voicemail: "#ea580c",
    })[type] || "#6b7280";

  ////////////// fake data for calls //////////////
  const refreshLead = {
    id: contact?.id,
    leadName: contact?.name,
    phone: contact?.phone,
    activities: [
      // {
      //   id: 1,
      //   type: "call",
      //   summary: "Initial Discussion Call",
      //   date: "2024-07-01T10:30:00",
      //   agent: "Hendry",
      //   duration: "12m 45s",
      //   details:
      //     "Discussed product requirements and pricing structure. Client showed interest in premium plan.",
      // },
    ],
  };

  const fmtDate = (iso) =>
    new Date(iso).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  const fmtTime = (iso) =>
    new Date(iso).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
    });
  const fmtDateTime = (iso) => `${fmtDate(iso)} ${fmtTime(iso)}`;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0  !pr-0 z-[60] flex items-stretch justify-end bg-slate-900/40 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.aside
            ref={containerRef}
            initial={{ x: 40, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 40, opacity: 0 }}
            transition={{ type: "spring", stiffness: 380, damping: 32 }}
            className="relative mt-0 mr-0 mb-auto ml-0 flex h-full p-[28px] pb-0  w-[800px] max-w-[98vw] flex-col overflow-hidden rounded-3xl rounded-r-none  border border-solid border-slate-200 bg-[#ffffff] shadow-xl"
            aria-modal
            role="dialog"
          >
            {isLoading ? (
              <>
                {/* Header */}
                <div className="bg-white/90  backdrop-blur supports-[backdrop-filter]:bg-white/70 w-full">
                  <div className="flex flex-wrap items-center justify-between gap-3 w-full pb-4">
                    <div className="flex min-w-0 items-center gap-3">
                      <div className="flex items-center justify-center size-12 bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 rounded-full overflow-hidden">
                        <p className="capitalize font-semi-bold text-base text-black">
                          {contact?.name
                            ?.split(" ")
                            ?.map((n, i) => n.charAt(0))}
                        </p>
                      </div>
                      <div className="min-w-0">
                        <div className="flex  items-center gap-2">
                          <h2 className="text-xl font-bold text-slate-900">
                            {contact?.name}
                          </h2>
                          <Chip2
                            label={
                              contact?.verified == 0
                                ? "Not Verified"
                                : "Verified"
                            }
                            tone={
                              contact?.verified == 0 ? "warning" : "success"
                            }
                          />
                        </div>
                        <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-slate-500">
                          <span className="inline-flex items-center gap-1">
                            <MailCheck className="size-4" /> {contact?.email}
                          </span>

                          <span className="inline-flex items-center gap-1">
                            <PhoneCall className="size-4" /> {contact?.phone}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-wrap items-center gap-2">
                      <button
                        className="inline-flex items-center gap-1.5 rounded-xl bg-[#0B54FF] px-3 py-2 text-sm font-medium text-white hover:bg-[#0849e0]"
                        onClick={onClose}
                        aria-label="Close"
                      >
                        <X className="size-4" /> Exit
                      </button>
                    </div>
                  </div>
                </div>

                {/* Body */}
                <div className="grid min-h-0 flex-1 grid-cols-1 gap-4 overflow-hidden pt-0 w-full">
                  {/* Left: main content */}
                  <div className="col-span-12 flex min-h-0 flex-col gap-4">
                    {/* Top stats */}
                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        // marginTop: 14,
                        flexWrap: "wrap",
                        textTransform: "capitalize"

                      }}
                    >
                      {contact?.stats?.map(
                        (ele, idx) =>
                          ele?.value !== "-" &&
                          ele?.value !== null && (
                            <div
                              style={{
                                padding: "8px 14px",
                                background: "#F3EFE9",
                                borderRadius: 10,
                                border: `1px solid rgba(0,0,0,0.08)`,
                              }}
                            >
                              <div style={{ fontSize: 10, color: "#908892" }}>
                                {ele?.key?.includes("_")
                                  ? ele?.key
                                    ?.split("_")
                                    .map((word) => ` ${word}`)
                                  : ele?.key}
                              </div>
                              <div
                                style={{
                                  fontSize: 15,
                                  fontWeight: 700,
                                  marginTop: 3,
                                  color: "#1a1520",
                                }}
                              >
                                {ele?.value}
                              </div>
                            </div>
                          ),
                      )}
                    </div>

                    <div className="flex flex-wrap items-center gap-2 ">
                      <button
                        className="inline-flex items-center gap-1.5 tracking-normal rounded-lg bg-[linear-gradient(92deg,#0057FB_1.54%,#003495_114.12%)] 
                                               hover:bg-[linear-gradient(92deg,#0066FF_1.54%,#0045AA_114.12%)] px-[18px] py-2 text-[13px] font-semibold text-white"
                        onClick={() => setShowActivityModal(true)}
                        aria-label="Close"
                      >
                        <Plus className="size-[14px]" /> Add Follow Up
                      </button>

                      <button
                        className="inline-flex items-center gap-1.5 rounded-lg border border-solid border-[rgba(0,0,0,0.1)] bg-[rgb(243,239,233)] px-[18px] py-2 text-[13px] font-medium text-[rgb(26,21,32)] hover:bg-slate-50"
                        onClick={() => setShowAddDealModal(true)}
                      >
                        <Briefcase className="size-[14px]" /> Add Deal
                      </button>
                    </div>

                    {/* Tabs */}

                    <div className="border-y border-solid pt-1 border-slate-200 flex items-center justify-between gap-2">
                      <div className="flex flex-wrap items-center gap-1">
                        {tabs?.map((t) => (
                          <button
                            key={t.key}
                            onClick={() => setActiveTab(t.key)}
                            className={classNames(
                              "flex items-center gap-[6px] px-[16px] py-[11px] text-[13px] font-normal border-b-2 transition-all duration-200",
                              activeTab === t.key
                                ? "border-blue-600 text-blue-600 font-semibold"
                                : "border-transparent text-slate-500 hover:text-slate-800",
                            )}
                          >
                            {t.icon}
                            {t.label}
                          </button>
                        ))}
                      </div>
                    </div>

                    <div className="h-full overflow-auto rounded-2xl py-2">
                      {activeTab === "timeline" && (
                        // <div className="px-2 w-full h-full rounded-md">
                        //   {contact?.activities?.map((act, i) => {
                        //     const config =
                        //       activityConfig[act.type] || activityConfig.note;
                        //     // const Icon = config.icon;
                        //     // const color = config.color;
                        //     return (
                        //       <div
                        //         key={act.id}
                        //         style={{
                        //           display: "flex",
                        //           gap: 12,
                        //           marginBottom: 16,
                        //         }}
                        //       >
                        //         <div
                        //           style={{
                        //             display: "flex",
                        //             flexDirection: "column",
                        //             alignItems: "center",
                        //           }}
                        //         >
                        //           <div
                        //             style={{
                        //               width: 34,
                        //               height: 34,
                        //               borderRadius: "50%",
                        //               background:
                        //                 activityColor(
                        //                   act?.type?.toLowerCase(),
                        //                 ) + "12",
                        //               display: "flex",
                        //               alignItems: "center",
                        //               justifyContent: "center",
                        //               color: activityColor(
                        //                 act?.type?.toLowerCase(),
                        //               ),
                        //               flexShrink: 0,
                        //             }}
                        //           >
                        //             {I(
                        //               activityIcon(act?.type?.toLowerCase()),
                        //               15,
                        //             )}
                        //           </div>
                        //           {i < contact.activities.length - 1 && (
                        //             <div
                        //               style={{
                        //                 width: 1,
                        //                 flex: 1,
                        //                 background: T.border,
                        //                 marginTop: 4,
                        //               }}
                        //             />
                        //           )}
                        //         </div>
                        //         <div style={{ flex: 1, paddingBottom: 4 }}>
                        //           <div
                        //             style={{
                        //               display: "flex",
                        //               justifyContent: "space-between",
                        //               alignItems: "center",
                        //               marginBottom: 2,
                        //             }}
                        //           >
                        //             <span
                        //               style={{
                        //                 fontSize: 13,
                        //                 fontWeight: 600,
                        //                 color: T.text,
                        //               }}
                        //               className="capitalize"
                        //             >
                        //               {act?.logcat}
                        //             </span>
                        //             <span
                        //               style={{
                        //                 fontSize: 11,
                        //                 color: T.textMuted,
                        //               }}
                        //             >
                        //               {act?.logtime}
                        //             </span>
                        //           </div>
                        //           <div
                        //             style={{
                        //               fontSize: 12,
                        //               color: T.textMuted,
                        //               marginBottom: 4,
                        //             }}
                        //           >
                        //             {act?.logtype} · {act?.user?.name} ·{" "}
                        //             {moment(
                        //               act?.logtime,
                        //               "DD-MMM-YYYY hh:mm:ss A",
                        //             ).fromNow()}
                        //           </div>
                        //           <div
                        //             style={{
                        //               fontSize: 12,
                        //               color: T.textSecondary,
                        //               lineHeight: 1.6,
                        //             }}
                        //           >
                        //             {act.log}
                        //           </div>
                        //         </div>
                        //       </div>
                        //     );
                        //   })}
                        //   {contact?.activities?.length === 0 && (
                        //     <div
                        //       style={{
                        //         textAlign: "center",
                        //         color: "#908892",
                        //         padding: 40,
                        //       }}
                        //     >
                        //       No activities logged yet
                        //     </div>
                        //   )}
                        // </div>

                        <PopupTimeline timeline={contact?.activities} />
                      )}

                      {activeTab === "summary" && (
                        <>
                          <div>
                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: T.text,
                                marginBottom: 12,
                              }}
                            >
                              Account Information
                            </div>

                            <div className="grid gap-6 md:grid-cols-2 w-full px-[10px]">
                              <FieldRow
                                label="Full Name"
                                value={contact?.name}
                                LabelIcon={ALargeSmall}
                              />
                              <FieldRow
                                label="Email"
                                value={contact?.email}
                                LabelIcon={Send}
                                isCapitalize={false}
                                isCopyable={true}
                              />

                              <FieldRow
                                label="Phone"
                                value={contact?.phone}
                                LabelIcon={PhoneCall}
                              />
                              <FieldRow
                                label="Product"
                                value={contact?.source}
                                LabelIcon={PackageSearch}
                              />

                              <FieldRow
                                label="Brand Name"
                                value={contact?.page_source}
                                LabelIcon={Slack}
                                isLink={true}
                                LinkValue={contact?.brandurl}
                              />
                              <FieldRow
                                label="Date"
                                value={contact?.signupdate}
                                LabelIcon={CalendarSync}
                              />

                              {/* <FieldRow label="First Name" value={contact?.email} LabelIcon={Send} />
                                                      <FieldRow label="First Name" value={contact?.email} LabelIcon={Send} /> */}
                            </div>
                          </div>

                          <div className="mt-[12px]">
                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: T.text,
                                marginBottom: 12,
                              }}
                            >
                              Contact Information
                            </div>

                            <div className="grid gap-6 md:grid-cols-2 w-full px-[10px]">
                              <FieldRow
                                label="Alternate Email"
                                value={contact?.altemail}
                                LabelIcon={MailCheckIcon}
                                isCapitalize={false}
                              />
                              <FieldRow
                                label="Alternate Phone"
                                value={contact?.alternatephone}
                                LabelIcon={PhoneIcon}
                                isCapitalize={false}
                              />

                              <FieldRow
                                label="Country"
                                value={contact?.country}
                                LabelIcon={Warehouse}
                              />
                              <FieldRow
                                label="State"
                                value={contact?.state}
                                LabelIcon={MapPinHouse}
                              />

                              <FieldRow
                                label="City"
                                value={contact?.city}
                                LabelIcon={MapMinus}
                              />
                              <FieldRow
                                label="Company"
                                value={contact?.companyname}
                                LabelIcon={Building2}
                              />

                              <FieldRow
                                label="Badge"
                                value={contact?.badge}
                                LabelIcon={BadgeAlert}
                              />
                              {/* <FieldRow label="First Name" value={contact?.email} LabelIcon={Send} /> */}
                            </div>
                          </div>
                        </>
                      )}

                      {activeTab === "notes" && <Notes />}
                      {activeTab === "assets" && (
                        <Assets assets={contact?.assets} />
                      )}
                      {activeTab === "activity" && (
                        <Activity items={contact?.activity} />
                      )}

                      {activeTab === "attendance" && (
                        <div className="space-y-3">
                          <Field
                            label="Status"
                            value={`${contact?.attendanceToday?.status} (${contact?.attendanceToday?.shiftAdherence})`}
                            icon={Clock}
                          />
                          <div className="rounded-2xl border border-solid border-slate-200 bg-white p-4">
                            <h4 className="mb-2 text-sm font-semibold">
                              Today at a glance
                            </h4>
                            <div className="grid grid-cols-3 gap-3 text-sm">
                              <MiniStat
                                label="Planned Shift"
                                value={contact?.shift}
                              />
                              <MiniStat
                                label="Hours Logged"
                                value={`${contact?.attendanceToday.hours}h`}
                              />
                              <MiniStat
                                label="Last Login"
                                value={contact?.lastLogin}
                              />
                            </div>
                          </div>
                          <div className="rounded-2xl border border-solid border-slate-200 bg-white p-4">
                            <h4 className="mb-2 text-sm font-semibold">
                              Leave Balance
                            </h4>
                            <div className="grid grid-cols-3 gap-3 text-sm">
                              {Object.entries(contact?.leaveBalance)?.map(
                                ([k, v]) => (
                                  <MiniStat
                                    key={k}
                                    label={capitalize(k)}
                                    value={`${v} days`}
                                  />
                                ),
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {activeTab === "deals" && (
                        <div className="space-y-3">
                          {contact?.client_deals?.length > 0 ? (
                            clientDeals.map((deal, i) => (
                              <DealCard
                                key={i}
                                userid={contact?.id}
                                deal={deal}
                                ProductList={ProductList}
                                PackageList={PackageList}
                                DealStages={DealStages}
                                ClientList={ClientList}
                                UserList={UserList}
                                onSubmit={handleSuccess}
                                onError={onError}
                                onStatusChange={(dealId, newStatus) => {
                                  // UPDATE STATE IMMEDIATELY
                                  setClientDeals((prevDeals) =>
                                    prevDeals.map((d) =>
                                      d.dealid === dealId
                                        ? {
                                          ...d,
                                          current_stage: {
                                            ...d.current_stage,
                                            dealstatus: newStatus,
                                          },
                                        } // new object
                                        : d,
                                    ),
                                  );
                                }}
                              />
                            ))
                          ) : (
                            <div className="text-sm text-slate-500">
                              No deals found for this contact.
                            </div>
                          )}
                        </div>
                      )}

                      {activeTab === "comments" && (
                        <CommentsSection
                          type="contact"
                          id={contact?.id}
                          title="true"
                          apiBaseUrl="contact"
                          setAlertData={setAlertData}
                          IsVerified={contact?.verified}
                          condition={"contact"}
                          commentTypes={commentTypes}
                          handleVerificationChange={handleVerificationChange}
                        />
                      )}

                      {activeTab === "call" && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 12,
                          }}
                        >
                          <div style={css.card}>
                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: T.text,
                                marginBottom: 12,
                              }}
                            >
                              Make a Call
                            </div>
                            <div
                              style={{
                                display: "flex",
                                gap: 8,
                                marginBottom: 16,
                              }}
                            >
                              <input
                                style={{ ...css.input, flex: 1 }}
                                value={refreshLead.phone}
                                readOnly
                              />
                              <button style={css.btnPrimary}>
                                <Icon name="phone" size={14}/>Call Now
                              </button>
                            </div>
                          </div>
                          <div
                            style={{
                              fontSize: 14,
                              fontWeight: 600,
                              color: T.text,
                              marginBottom: 8,
                            }}
                          >
                            Call History
                          </div>
                          {refreshLead.activities
                            .filter(
                              (a) =>
                                a.type === "call" || a.type === "voicemail",
                            )
                            .map((call) => (
                              <div
                                key={call.id}
                                style={{
                                  ...css.card,
                                  display: "flex",
                                  gap: 12,
                                }}
                              >
                                <div
                                  style={{
                                    width: 34,
                                    height: 34,
                                    borderRadius: "50%",
                                    background: activityColor(call.type) + "12",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: activityColor(call.type),
                                    flexShrink: 0,
                                  }}
                                >
                                  {/* {I(activityIcon(call.type), 15)} */}
                                   <Icon name="call" size={15}/>
                                </div>
                                <div style={{ flex: 1 }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      marginBottom: 2,
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: 13,
                                        fontWeight: 600,
                                        color: T.text,
                                      }}
                                    >
                                      {call.summary}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: 11,
                                        color: T.textMuted,
                                      }}
                                    >
                                      {fmtDateTime(call.date)}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      fontSize: 12,
                                      color: T.textMuted,
                                      marginBottom: 4,
                                    }}
                                  >
                                    {call.agent} · {call.duration}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: 12,
                                      color: T.textSecondary,
                                    }}
                                  >
                                    {call.details}
                                  </div>
                                </div>
                              </div>
                            ))}
                          {refreshLead.activities.filter(
                            (a) => a.type === "call" || a.type === "voicemail",
                          ).length === 0 && (
                              <div
                                style={{
                                  textAlign: "center",
                                  color: T.textMuted,
                                  padding: 40,
                                }}
                              >
                                No call history
                              </div>
                            )}
                        </div>
                      )}

                      {activeTab === "emails" && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 12,
                          }}
                        >
                          <div style={css.card}>
                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: T.text,
                                marginBottom: 12,
                              }}
                            >
                              Compose Email
                            </div>
                            <input
                              placeholder="Subject..."
                              style={{ ...css.input, marginBottom: 8 }}
                            />
                            <textarea
                              placeholder="Type your email message..."
                              style={{
                                ...css.input,
                                minHeight: 120,
                                resize: "vertical",
                                marginBottom: 8,
                              }}
                            />
                            <button style={css.btnPrimary}>
                              {/* {I("send", 14)} Send Email */}
                               <Icon name="send" size={14}/> Send Email
                            </button>
                          </div>
                          <div
                            style={{
                              fontSize: 14,
                              fontWeight: 600,
                              color: T.text,
                              marginBottom: 8,
                            }}
                          >
                            Email History
                          </div>
                          {refreshLead.activities
                            .filter((a) => a.type === "email")
                            .map((email) => (
                              <div key={email.id} style={{ ...css.card }}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: 6,
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: 13,
                                      fontWeight: 600,
                                      color: T.text,
                                    }}
                                  >
                                    {email.summary}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: 11,
                                      color: T.textMuted,
                                    }}
                                  >
                                    {fmtDateTime(email.date)}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    fontSize: 12,
                                    color: T.textMuted,
                                    marginBottom: 4,
                                  }}
                                >
                                  From: {email.agent}
                                </div>
                                <div
                                  style={{
                                    fontSize: 13,
                                    color: T.textSecondary,
                                    lineHeight: 1.6,
                                  }}
                                >
                                  {email.details}
                                </div>
                              </div>
                            ))}
                          {refreshLead.activities.filter(
                            (a) => a.type === "email",
                          ).length === 0 && (
                              <div
                                style={{
                                  textAlign: "center",
                                  color: T.textMuted,
                                  padding: 40,
                                }}
                              >
                                No email history
                              </div>
                            )}
                        </div>
                      )}

                      {activeTab === "sms" && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 12,
                          }}
                        >
                          <div style={css.card}>
                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: T.text,
                                marginBottom: 12,
                              }}
                            >
                              Send SMS
                            </div>
                            <textarea
                              placeholder="Type your message..."
                              style={{
                                ...css.input,
                                minHeight: 80,
                                resize: "vertical",
                                marginBottom: 8,
                              }}
                            />
                            <button style={css.btnPrimary}>
                              {/* {I("send", 14)} Send SMS */}
                              <Icon name="send" size={14}/> Send SMS
                              
                            </button>
                          </div>
                          <div
                            style={{
                              fontSize: 14,
                              fontWeight: 600,
                              color: T.text,
                              marginBottom: 8,
                            }}
                          >
                            SMS History
                          </div>
                          {refreshLead.activities
                            .filter((a) => a.type === "sms")
                            .map((sms) => (
                              <div key={sms.id} style={{ ...css.card }}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: 6,
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: 13,
                                      fontWeight: 600,
                                      color: T.text,
                                    }}
                                  >
                                    {sms.summary}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: 11,
                                      color: T.textMuted,
                                    }}
                                  >
                                    {fmtDateTime(sms.date)}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    fontSize: 12,
                                    color: T.textMuted,
                                    marginBottom: 4,
                                  }}
                                >
                                  {sms.agent}
                                </div>
                                <div
                                  style={{
                                    fontSize: 13,
                                    color: T.textSecondary,
                                    lineHeight: 1.6,
                                  }}
                                >
                                  {sms.details}
                                </div>
                              </div>
                            ))}
                          {refreshLead.activities.filter(
                            (a) => a.type === "sms",
                          ).length === 0 && (
                              <div
                                style={{
                                  textAlign: "center",
                                  color: T.textMuted,
                                  padding: 40,
                                }}
                              >
                                No SMS history
                              </div>
                            )}
                        </div>
                        // <TabPlaceholder
                        //   icon={MessageSquare}
                        //   title="SMS"
                        //   message="SMS communication history is under development."
                        // />
                      )}
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div className="flex items-center justify-between gap-2 border-t border-solid border-slate-200 bg-white p-3 w-full">
                  <div className="flex items-center gap-2 text-xs text-slate-500">
                    <IdCard className="size-4" /> ID {contact?.id}
                    {/* <span>•</span>
                        <CalendarDays className="size-4" /> Joined {formatDate(contact?.doj)} */}
                  </div>
                  <div className="flex items-center gap-2">
                    {/* <button
                          className="rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm hover:bg-slate-50"
                          onClick={() => {
                            setActiveTab('notes');
                            setTimeout(() => {
                              const el = document.getElementById("addNotesField");
                              el?.focus();
                            }, 250);
                          }}>
                          <StickyNote className="mr-1 inline size-4" />
                          Add Note
                        </button> */}
                    {/* <button className="rounded-xl bg-slate-900 px-3 py-2 text-sm text-white hover:bg-slate-800">Save Changes</button> */}
                  </div>
                </div>
              </>
            ) : (
              <InnerLoader wrapperClass={"w-full"} />
            )}
          </motion.aside>

          {showAddDealModal && (
            <EmployeeDirectoryAddUpdate
              open={showAddDealModal}
              onClose={() => {
                setShowAddDealModal(false);
              }}
              data={{ contactid: contact?.id }}
              tabIndex={1}
              contactId={contact?.id}
              onDealUpdated={() => GetData(contact?.id)} // refresh after update
              onSubmit={handleSuccess}
              onError={onError}
            />
          )}

          {showActivityModal && (
            <AddActivity
              onSubmit={onActivitySuccess}
              onClose={() => {
                setShowActivityModal(false);
              }}
              onError={onError}
              UsersList={usersList}
              CustomerData={null}
              id={contact?.id}
              entitytype="contact"
              entityname={contact.name}
            />
          )}

          <Snackbar
            open={alertData?.isShow}
            autoHideDuration={3000}
            onClose={handleClose}
          >
            <Alert
              onClose={handleClose}
              severity={alertData?.type}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {alertData?.message}
            </Alert>
          </Snackbar>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

function QuickAction({ icon: Icon, label, href, onClick }) {
  const className =
    "inline-flex items-center gap-1.5 rounded-xl border border-solid border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50";
  if (href)
    return (
      <a className={className} href={href}>
        <Icon className="size-4" /> {label}
      </a>
    );
  return (
    <button className={className} onClick={onClick}>
      <Icon className="size-4" /> {label}
    </button>
  );
}

function Activity({ items, compact = false }) {
  return (
    <ul className="space-y-3">
      {items?.map((a, i) => (
        <li key={i} className="flex items-start gap-3">
          <div className="mt-1 h-5 w-5 rounded-full bg-slate-100 ring-1 ring-slate-200" />
          <div className="min-w-0 flex-1">
            <div className="text-[13px] text-slate-800 pb-[5px]">{a.text}</div>
            <div className="text-[11px] text-slate-400">{formatTs(a.ts)}</div>
          </div>
        </li>
      ))}
      {!compact && (
        <button className="mt-1 inline-flex items-center gap-1 text-xs text-slate-600 hover:underline">
          View full activity <ChevronRight className="size-4" />
        </button>
      )}
    </ul>
  );
}

function Assets({ assets }) {
  return (
    <div className="space-y-3">
      {assets?.map((a, i) => (
        <div
          key={i}
          className="flex items-center justify-between rounded-xl border border-solid border-slate-200 bg-white p-3"
        >
          <div className="flex min-w-0 items-center gap-3">
            <Monitor className="size-5" />
            <div className="min-w-0">
              <div className="truncate text-sm font-medium">{a.name}</div>
              <div className="truncate text-xs text-slate-500">{a.id}</div>
            </div>
          </div>
          {/* <Badge tone={a.status === "Assigned" ? "blue" : "grey"}>{a.status}</Badge> */}
        </div>
      ))}
      <button className="inline-flex items-center gap-1 text-xs text-slate-600 hover:underline">
        Manage assets <ChevronRight className="size-4" />
      </button>
    </div>
  );
}

function Notes() {
  const [notes, setNotes] = useState([
    {
      id: 1,
      text: "Great initiative on latest branding sprint. Keep momentum for Q4.",
      ts: Date.now() - 86400000,
    },
  ]);
  const [text, setText] = useState("");
  return (
    <div className="space-y-3">
      <div className="rounded-2xl border border-solid border-slate-200 bg-white p-3">
        <textarea
          id="addNotesField"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Add a manager note (visible to HR/Managers)…"
          className="min-h-[90px] w-full resize-y rounded-xl border border-solid border-slate-200 bg-slate-50 p-3 text-sm outline-none focus:ring-2 focus:ring-slate-900/10"
        />
        <div className="mt-2 flex justify-end">
          <button
            onClick={() => {
              if (!text.trim()) return;
              setNotes((n) => [{ id: Date.now(), text, ts: Date.now() }, ...n]);
              setText("");
            }}
            className="rounded-xl bg-slate-900 px-3 py-1.5 text-xs text-white hover:bg-slate-800"
          >
            Save Note
          </button>
        </div>
      </div>
      <ul className="space-y-2">
        {notes?.map((n) => (
          <li
            key={n.id}
            className="rounded-xl border border-solid border-slate-200 bg-white p-3"
          >
            <div className="text-sm text-slate-800">{n.text}</div>
            <div className="text-[11px] text-slate-400">
              {new Date(n.ts).toLocaleString()}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

function MiniStat({ label, value }) {
  return (
    <div className="rounded-xl border border-solid border-slate-200 bg-slate-50 p-3 text-center">
      <div className="text-[11px] text-slate-500">{label}</div>
      <div className="text-sm font-semibold text-slate-800">{value}</div>
    </div>
  );
}

function formatDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

function formatTs(ts) {
  try {
    const d =
      typeof ts === "string" ? new Date(ts.replace(" ", "T")) : new Date(ts);
    return d.toLocaleString();
  } catch {
    return String(ts);
  }
}

function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

function DealCard({
  deal,
  userid,
  onStatusChange,
  onCommentAdd,
  ProductList = [],
  PackageList = [],
  DealStages = [],
  ClientList = [],
  UserList = [],
  onSubmit = () => { },
  onError = () => { },
}) {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showWonModal, setShowWonModal] = useState(false);
  const [wonFormDeal, setWonFormDeal] = useState(null);
  const [showLostModal, setShowLostModal] = useState(false);
  const [lostFormDeal, setLostFormDeal] = useState(null);
  const [localStage, setLocalStage] = useState(
    deal?.current_stage?.dealstatus ?? "-",
  );

  const apiCall = useApiCall();

  const handleSuccess = (message, type) => {
    setShowWonModal(false);
    setShowLostModal(false);
    setShowEditModal(false);
    onSubmit(message, type); // ✅ call parent prop

    setEmpPopup(false);
    setEmpData({});
  };

  const handleError = (message) => {
    if (onError) onError(message); // ✅ call parent prop
  };

  // const stage = deal?.current_stage?.dealstatus ?? "-";

  const metas = Object.fromEntries(
    deal?.metas?.map((m) => [m.meta_key, m.meta_value]) ?? [],
  );

  const isWon = deal?.current_stage?.dealstatus === "Won";
  const isLost = deal?.current_stage?.dealstatus === "Lost";
  const currentStageIndex = DealStages.findIndex(
    (s) => s.name === deal?.current_stage?.dealstatus,
  );
  const activeColor = isWon ? "#22c55e" : isLost ? "#ef4444" : "#2563eb";
  const isWonOrLost = isWon || isLost;

  const [empPopup, setEmpPopup] = useState(false);
  const [empData, setEmpData] = useState({});

  const formatStageKey = (stage) => {
    return stage.toLowerCase().replace(/\s+/g, "_"); // "In Progress" -> "in_progress"
  };

  // --- HANDLE STAGE CHANGE ---
  const handleStageChange = async (newStage) => {
    const lowerStage = formatStageKey(newStage); // lowercase + underscores
    const currentStage = deal?.current_stage?.dealstatus ?? "-"; // ✅ added

    if (lowerStage === "won") {
      setWonFormDeal(deal);
      setShowWonModal(true);
      return;
    }

    if (lowerStage === "lost") {
      setLostFormDeal({ dealkey: deal.dealkey, name: deal.name });
      setShowLostModal(true);
      return;
    }

    const resultSwal = await Swal.fire({
      title: `Move deal "${deal.name}"?`,
      text: `Move from "${currentStage}" to "${newStage}"?`, // ✅ fixed reference
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    });

    if (resultSwal.isConfirmed) {
      try {
        await apiCall({
          method: "post",
          url: "deals/update-deal-status",
          data: { dealkey: deal.dealkey, dealstatus: lowerStage },
        });

        // **Update card immediately without reload**
        onStatusChange(deal.dealid, newStage); // ✅ keep `newStage` or `lowerStage` depending on your display logic

        Swal.fire("Success!", `Deal moved to "${newStage}"`, "success");
      } catch (err) {
        Swal.fire(
          "Error",
          err?.response?.data?.message || "Something went wrong",
          "error",
        );
      }
    }
  };

  return (
    <>
      <div
        className="relative rounded-xl border border-slate-200 bg-white px-5 py-4 
             shadow-sm hover:shadow-md transition-all duration-300 
             space-y-3 text-sm w-full cursor-pointer hover:-translate-y-[1px]"
      >
        {/* Header */}
        <div className="flex justify-between items-start">
          <div className="flex flex-col">
            <h3 className="font-semibold text-slate-800 flex items-center gap-2 text-[15px]">
              <Briefcase className="size-4 text-blue-600" />
              {deal?.name ?? "Untitled Deal"}{" "}
              <span className="text-xs text-slate-500">#{deal?.dealid}</span>
            </h3>
          </div>

          <span className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2.5 py-0.5 text-xs font-medium text-blue-700">
            {metas?.dealamount ? `$${metas?.dealamount}` : "—"}
          </span>
        </div>

        {/* Stage Pipeline */}
        <div className="mt-2">
          <p className="text-xs text-slate-500 mb-1 font-medium">
            Stage Pipeline
          </p>
          <div className="flex w-full h-7 overflow-hidden rounded-md">
            {DealStages.map((s, i) => {
              const isActive = !isWonOrLost && i <= currentStageIndex;
              const isCurrent = i === currentStageIndex;
              const isFirst = i === 0;
              const isLast = i === DealStages.length - 1;

              let clipPath = "";
              if (isFirst) {
                clipPath =
                  "polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%)";
              } else if (isLast) {
                clipPath = "polygon(0 0, 10px 50%, 0 100%, 100% 100%, 100% 0)";
              } else {
                clipPath =
                  "polygon(0 0, 10px 50%, 0 100%, calc(100% - 10px) 100%, 100% 50%, calc(100% - 10px) 0)";
              }

              return (
                <div
                  key={s.id}
                  onClick={() =>
                    !isWonOrLost && !isCurrent && handleStageChange(s.name)
                  } // s.name will automatically go lowercase in handleStageChange
                  title={s.name}
                  style={{
                    clipPath,
                    WebkitClipPath: clipPath,
                    backgroundColor:
                      i <= currentStageIndex && !isWonOrLost
                        ? activeColor
                        : "#e5e7eb",
                    transition: "background-color 0.3s ease",
                    cursor:
                      isWonOrLost || isCurrent ? "not-allowed" : "pointer",
                  }}
                  className="flex-1 relative flex items-center justify-center text-[10px] font-medium text-white select-none"
                >
                  {i <= currentStageIndex && !isWonOrLost ? (
                    <Check className="size-3" />
                  ) : (
                    s.name[0]
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Actions Row */}
        <div className="flex justify-between items-center mt-4">
          {/* Won/Lost Badge */}
          <div>
            {(isWon || isLost) && (
              <div
                className={`flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium ${isWon
                  ? "bg-green-100 text-green-700"
                  : "bg-rose-100 text-rose-700"
                  }`}
              >
                {isWon ? (
                  <Trophy className="size-3" />
                ) : (
                  <XCircle className="size-3" />
                )}
                {isWon ? "Won" : "Lost"}
              </div>
            )}
            {!isWon && !isLost && <div className="h-[22px]" />}
          </div>

          {/* Action Icons */}
          <div className="flex items-center gap-3">
            {/* <button
              onClick={() => {
                setEmpPopup(true);
                setEmpData(deal);
              }}
              title="Quick View"
              className="p-2 rounded-full bg-slate-100 hover:bg-blue-100 hover:text-blue-600 text-slate-500 transition"
            >
              <Eye className="size-4" />
            </button> */}

            <Link
              to={`/lead-account/detail/${userid}/deal/${deal?.dealid}`}
              target="_blank"
              className={
                "p-2 rounded-lg  hover:text-[#34C759] hover:bg-slate-100 text-slate-600 transition "
              }
            >
              <div className="flex max-w-4 max-h-4 ">
                <NewCardIcon className="h-4.5 w-4.5" />
              </div>
            </Link>

            <button
              onClick={() => !isWonOrLost && setShowEditModal(true)}
              className={`p-2 rounded-lg hover:text-[#007AFF]  hover:bg-slate-100 text-slate-600 transition ${isWonOrLost ? "opacity-40 cursor-not-allowed" : ""
                }`}
              title="Edit Deal"
              disabled={isWonOrLost} // <- button ko bhi disable kar diya
            >
              <Pencil size={16} />
            </button>

            <button
              onClick={() => !isWonOrLost && handleStageChange("Won")}
              title="Mark as Won"
              className={`p-2 rounded-full transition ${isWonOrLost ? "cursor-not-allowed" : "cursor-pointer"} ${isWon
                ? "bg-green-500 text-white"
                : "bg-slate-100 text-slate-500 hover:bg-green-100 hover:text-green-600"
                }`}
            >
              <ThumbsUp className="size-4" />
            </button>

            <button
              onClick={() => !isWonOrLost && handleStageChange("Lost")}
              title="Mark as Lost"
              className={`p-2 rounded-full transition ${isWonOrLost ? "cursor-not-allowed" : "cursor-pointer"} ${isLost
                ? "bg-rose-500 text-white"
                : "bg-slate-100 text-slate-500 hover:bg-rose-100 hover:text-rose-600"
                }`}
            >
              <ThumbsDown className="size-4" />
            </button>
          </div>
        </div>
      </div>

      {showEditModal && (
        // <EditDealModal
        //   open={showEditModal}
        //   onClose={() => setShowEditModal(false)}
        //   dealData={deal}
        //   PackageList={PackageList}
        //   DealStages={DealStages}
        //   ProductList={ProductList}
        //   ClientList={ClientList}
        //   UserList={UserList}
        //   contactId={userid}
        //   onDealUpdated={() => onStatusChange(deal.dealid)}
        //   onSubmit={handleSuccess}
        //   onError={handleError}
        // />

        <EmployeeDirectoryAddUpdate
          open={showEditModal}
          onClose={() => {
            setShowEditModal(false);
          }}
          data={deal}
          tabIndex={1}
          contactId={userid}
          onDealUpdated={() => onStatusChange(deal.dealid)} // refresh after update
          onSubmit={handleSuccess}
          onError={handleError}
        />
      )}

      {/* Won Deal Modal */}
      {showWonModal && (
        <WonDeal
          wonFormDeal={wonFormDeal}
          onClose={() => setShowWonModal(false)}
          onDealUpdated={() => onStatusChange(deal.dealid)}
          onSubmit={handleSuccess}
          onError={handleError}
        />
      )}

      {showLostModal && (
        <LostDeal
          lostFormDeal={lostFormDeal}
          onClose={() => setShowLostModal(false)}
          onSubmit={handleSuccess}
          onError={handleError}
        />
      )}

      {empPopup && (
        <DealQuickView
          onClose={() => {
            setEmpPopup(false);
            setEmpData({});
          }}
          data={empData}
          DealStages={DealStages}
          onSuccess={handleSuccess}
          onError={handleError}
        />
      )}
    </>
  );
}

function TabPlaceholder({ icon: Icon, title, message }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center border border-dashed border-slate-300 rounded-2xl bg-white">
      <div className="flex items-center justify-center size-14 rounded-full bg-slate-100 mb-4">
        <Icon className="size-6 text-slate-500" />
      </div>
      <h3 className="text-lg font-semibold text-slate-700">{title}</h3>
      <p className="text-sm text-slate-500 mt-1">{message}</p>
      <div className="mt-4 px-4 py-2 text-xs text-slate-400 border border-solid border-slate-200 rounded-full bg-slate-50">
        🚧 Under Development
      </div>
    </div>
  );
}
